import React, { useEffect, useState } from "react";
import { Box, Button, Calendar, Collapsible, Tip } from "grommet";
import { Schedule, CaretRightFill } from "grommet-icons";
import { useAuthenticator } from "@aws-amplify/ui-react";
import useDisabledDates from "../hooks/useDisabledDates";

function CalendarPortal({
  calendarOpen,
  setCalendarOpen,
  calendarRef,
  setSelectedDate,
}) {
  const { user } = useAuthenticator();

  const [currentMonth, setCurrentMonth] = useState(new Date().toISOString());
  const disabledDates = useDisabledDates({ user, month: currentMonth });
  const [selectedCalendarDate, setSelectedCalendarDate] = useState(
    new Date().toISOString(),
  );
  const today = new Date().toISOString().split("T")[0];

  const [showBackToToday, setShowBackToToday] = useState(false);

  useEffect(() => {
    if (!user) {
      setCalendarOpen(false);
    }
  }, [user, setCalendarOpen]);

  useEffect(() => {
    // Check if the user is on today's date or not
    if (selectedCalendarDate !== today) {
      setShowBackToToday(true);
    } else {
      setShowBackToToday(false);
    }
  }, [selectedCalendarDate, today]);

  const handleBackToToday = () => {
    setSelectedCalendarDate(today);
    setSelectedDate(today);
    // If you need to scroll to today, you can use calendarRef and handle that logic
    if (calendarRef.current) {
      calendarRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      {!user && (
        <Tip
          dropProps={{ align: { left: "right" } }}
          content="Please Sign-In to view calendar"
        >
          <Box align="start" gap="small" ref={calendarRef}>
            <Button
              onClick={() => setCalendarOpen(!calendarOpen)}
              icon={<Schedule color="black" />}
              disabled={!user}
            />
          </Box>
        </Tip>
      )}
      {user && (
        <Box align="start" gap="small" ref={calendarRef}>
          <Button
            onClick={() => setCalendarOpen(!calendarOpen)}
            icon={<Schedule color="black" />}
            disabled={!user}
          />

          <Collapsible open={calendarOpen}>
            <Box
              background="light-2"
              round="medium"
              pad="medium"
              style={{
                position: "absolute",
                top: "5em",
                zIndex: 1,
              }}
            >
              <Calendar
                className="calendar"
                date={selectedCalendarDate}
                animate={true}
                daysOfWeek
                activeDate="start"
                onSelect={(date) => {
                  setSelectedCalendarDate(date);
                  setSelectedDate(date);
                }}
                showAdjacentDays={false}
                bounds={
                  disabledDates === undefined ? [] : ["01-01-1970", today]
                }
                disabled={disabledDates}
                onReference={setCurrentMonth}
                size="medium"
                fill
                firstDayOfWeek={1}
              />
              {showBackToToday && (
                <Button
                  type="reset"
                  onClick={handleBackToToday}
                  icon={<CaretRightFill color="black" />}
                  label="Back to Today"
                  margin={{ top: "xsmall" }}
                  pad={{ horizontal: "small", vertical: "xsmall" }} // Make the button smaller
                  alignSelf="center" // Align the button to center
                  justify="center" // Ensure content is centered inside the button
                  style={{
                    border: "none", // Remove border
                    background: "transparent", // Optional: Make background transparent if needed
                  }}
                />
              )}
            </Box>
          </Collapsible>
        </Box>
      )}
    </>
  );
}

export default CalendarPortal;
